module.exports = "<div class=\"footer\">\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Client/app/components/common/footer/footer.component.html
// module id = 1540
// module chunks = 0